

export const DATA_TABLE_COLUMN_FIELD = {
  ID: 'id',
  PARENT_ID: 'parentId',
  NO_DATA: 'noData',
  EXPAND_WTH_DATA: 'expandWithData'
};